import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import Claim from '../../Views/ClaimWrapper/form/claim'
import {TabCentralModel} from '../../../../../models'
import ButtonClose from '../../../../../components/UI/Button/IconButton'
import {useCentral} from '../../../../../hooks/useCentral'
import {TableClaimDocumentsWrapper} from '../../Views/ClaimWrapper/table/TableClaimDocuments'
import {TableAttendClaimWrapper} from '../../Views/ClaimWrapper/table/TableAttendClaim'
const ClaimTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()

  const handleBack = () => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      loadingTable: true,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('ADJDOCUMENTO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Adjuntar Documentos</Tab>
          )}
          {isAllowed('ATENDREQUERIMIENTO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Atender Requerimiento</Tab>
          )}
        </TabList>
        <TabPanel>
          <Claim />
        </TabPanel>
        {isAllowed('ADJDOCUMENTO/ACCESO') && (
          <TabPanel>
            <TableClaimDocumentsWrapper />
          </TabPanel>
        )}
        {isAllowed('ATENDREQUERIMIENTO/ACCESO') && (
          <TabPanel>
            <TableAttendClaimWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default ClaimTab
